import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import AccountMenu from './AccountMenu';
import {  UserDataContext,ShoppingCartContext } from './Context';
import { useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import ListItemIcon from '@mui/material/ListItemIcon';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';







function AppAppBar() {
  const [open, setOpen] = React.useState(false);
  const [userData] = React.useContext(UserDataContext)
  const [shopCart] = React.useContext(ShoppingCartContext)
  const [shopCartItemCount, setShopCartItemCount] = React.useState(0)

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  

  const navigate = useNavigate()
 
  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
      setOpen(false);
    }
  };

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 13,
      border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
      padding: '0 4px',
    },
  }));


  React.useEffect(() => {
   
    if (shopCart?.items) {
      setShopCartItemCount(shopCart.items.reduce((quantity,item) => quantity + item.quantity, 0))
      return
    }
    setShopCartItemCount(0)
  },[shopCart])


  return (
    
    <div>
      <CssBaseline/>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 1,
        }}
      >
        
        <Container maxWidth="lg">
           
          <Toolbar
            variant="dense"
            sx={{
              display: "flex",
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '10px',
              maxHeight: 40,
              backdropFilter: 'blur(24px)',
              border: '0.5px solid',
              borderColor: 'divider',
              boxShadow: "0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)"
                  
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0,
              }}
            >
              
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <MenuItem
                  onClick={() => navigate("/")}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="text.primary" >
                    Home
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/orders")}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="text.primary" >
                    Orders
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/about")}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="text.primary" >
                    About
                  </Typography>
                </MenuItem>
              </Box>
            
            </Box>
             
            <Box
              sx={{
                display: "flex",
                gap: 3,
                alignItems: 'center',
                width: "100%",
                justifyContent: {xs: "space-between", md: "right"},
              }}
            >
            
                <Button
                  variant="text"
                  color="primary"
                  aria-label="menu"
                  onClick={toggleDrawer(true)}
                  sx={{ minWidth: '30px', p: '4px',display:{ md: "none"}}}
                >
                <MenuIcon />
              </Button>
              <Box sx={{
                display: 'flex',
                gap: 3
              }}>
                <IconButton aria-label="cart" onClick={()=> navigate("/shopcart")}>
                <StyledBadge badgeContent={shopCartItemCount} color="secondary" showZero>
                  <ShoppingCartIcon />
                </StyledBadge>
              </IconButton>
              {userData.userIsLogin ? 
              (<AccountMenu />)
               :
              (<Button
                // color="trasparent"
                variant="text"
                size="small"
                onClick={() => navigate("/signin")}
                sx={{textTransform: 'none' }}
              >
                <Typography sx={{fontFamily: "Helvetica"}}>Sign in</Typography>
              </Button>)
                }
                </Box>
            
            
              
              <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 1,
                    backgroundColor: 'background.paper',
                    flexGrow: 1,
                  }}
                >
                  
                 
                  <MenuItem onClick={() => 
                    {
                      navigate("/");
                      setOpen(false);
                  }
                    }>
                    <ListItemIcon>
                      <HomeOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Home
                  </MenuItem>
                  <MenuItem onClick={() => 
                    {
                      navigate("/orders");
                      setOpen(false);
                  }
                    }>
                    <ListItemIcon>
                      <ListAltIcon fontSize="small" />
                    </ListItemIcon>
                    Orders
                  </MenuItem>
                  <MenuItem onClick={() => {
                    navigate("/about");
                     setOpen(false);
                  }}>
                     <ListItemIcon>
                      <InfoOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    About
                  </MenuItem>
                 
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
    
  );
}



export default AppAppBar;
